<!--
 *                        ::
 *                       :;J7, :,                        ::;7:
 *                       ,ivYi, ,                       ;LLLFS:
 *                       :iv7Yi                       :7ri;j5PL
 *                      ,:ivYLvr                    ,ivrrirrY2X,
 *                      :;r@Wwz.7r:                :ivu@kexianli.
 *                     :iL7::,:::iiirii:ii;::::,,irvF7rvvLujL7ur
 *                    ri::,:,::i:iiiiiii:i:irrv177JX7rYXqZEkvv17
 *                 ;i:, , ::::iirrririi:i:::iiir2XXvii;L8OGJr71i
 *               :,, ,,:   ,::ir@mingyi.irii:i:::j1jri7ZBOS7ivv,
 *                  ,::,    ::rv77iiiriii:iii:i::,rvLq@huhao.Li
 *              ,,      ,, ,:ir7ir::,:::i;ir:::i:i::rSGGYri712:
 *            :::  ,v7r:: ::rrv77:, ,, ,:i7rrii:::::, ir7ri7Lri
 *           ,     2OBBOi,iiir;r::        ,irriiii::,, ,iv7Luur:
 *         ,,     i78MBBi,:,:::,:,  :7FSL: ,iriii:::i::,,:rLqXv::
 *         :      iuMMP: :,:::,:ii;2GY7OBB0viiii:i:iii:i:::iJqL;::
 *        ,     ::::i   ,,,,, ::LuBBu BBBBBErii:i:i:i:i:i:i:r77ii
 *       ,       :       , ,,:::rruBZ1MBBqi, :,,,:::,::::::iiriri:
 *      ,               ,,,,::::i:  @arqiao.       ,:,, ,:::ii;i7:
 *     :,       rjujLYLi   ,,:::::,:::::::::,,   ,:i,:,,,,,::i:iii
 *     ::      BBBBBBBBB0,    ,,::: , ,:::::: ,      ,,,, ,,:::::::
 *     i,  ,  ,8BMMBBBBBBi     ,,:,,     ,,, , ,   , , , :,::ii::i::
 *     :      iZMOMOMBBM2::::::::::,,,,     ,,,,,,:,,,::::i:irr:i:::,
 *     i   ,,:;u0MBMOG1L:::i::::::  ,,,::,   ,,, ::::::i:i:iirii:i:i:
 *     :    ,iuUuuXUkFu7i:iii:i:::, :,:,: ::::::::i:i:::::iirr7iiri::
 *     :     :rk@Yizero.i:::::, ,:ii:::::::i:::::i::,::::iirrriiiri::,
 *      :      5BMBBBBBBSr:,::rv2kuii:::iii::,:i:,, , ,,:,:i@petermu.,
 *           , :r50EZ8MBBBBGOBBBZP7::::i::,:::::,: :,:,::i;rrririiii::
 *               :jujYY7LS0ujJL7r::,::i::,::::::::::::::iirirrrrrrr:ii:
 *            ,:  :@kevensun.:,:,,,::::i:i:::::,,::::::iir;ii;7v77;ii;i,
 *            ,,,     ,,:,::::::i:iiiii:i::::,, ::::iiiir@xingjief.r;7:i,
 *         , , ,,,:,,::::::::iiiiiiiiii:,:,:::::::::iiir;ri7vL77rrirri::
 *          :,, , ::::::::i:::i:::i:i::,,,,,:,::i:i:::iir;@Secbone.ii:::
 * 
 * @Author: xupeng ‘18309854921@163.com’
 * @Date: 2024-09-03 13:34:40
 * @LastEditors: xupeng ‘18309854921@163.com’
 * @LastEditTime: 2024-09-13 16:20:51
 * @FilePath: \admin\src\views\warehouse\detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 -->

<template>
  <div class="page_body" v-loading="isRequestLoading">
    <div class="data_main">
        <h1>仓库信息</h1>
        <div class="data_detail mt24">
            <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="98px">
                <el-form-item label="仓库名称：">
                    <span class="text">{{infoData.warehouseName}}</span>
                </el-form-item>
                <el-form-item label="事业部负责人：">
                    <span class="text">{{infoData.name}}</span>
                </el-form-item>

                <el-form-item label="联系电话：">
                    <span class="text">{{infoData.phone}}</span>
                </el-form-item>
                <el-form-item label="商家库房编号：">
                    <span class="text">{{infoData.isvWarehouseNo}}</span>
                </el-form-item>

                <el-form-item label="商品编号：">
                    <span class="text">{{infoData.goodsNo}}</span>
                </el-form-item>
                <el-form-item label="库存：">
                    <span class="text">{{infoData.availableQty?infoData.availableQty:'0'}}</span>
                </el-form-item>

                <el-form-item label="仓库所在地：">
                    <span class="text">{{infoData.province}} {{infoData.city}} {{infoData.town}}</span>
                </el-form-item>

                <el-form-item label="仓库详细地址：">
                    <span class="text">{{infoData.address}}</span>
                </el-form-item>


            </el-form>
        </div>
    </div>

      <div class="page_footer mt24">
          <el-button type="default" size="small" @click="$router.go(-1)">返 回</el-button>
      </div>
  </div>
</template>

<script>
import {getWarehouseDetail} from '@/api'
export default {
  name: "warehouseDetail",
  data () {
    return {
      isRequestLoading: false,
      infoData: {
        legalRepresentativeCardValidity: ''
      },
      classData: []
    }
  },
  created() {
    this.getInfo()
    // this.getMerchantClass()
  },
  methods: {
    getInfo () {
      this.isRequestLoading = true
      getWarehouseDetail(this.$route.query.id).then(res => {
        this.isRequestLoading = false
        if (res.code === 0) {
          this.infoData = res.data
        }
      }).catch(() => {
        this.isRequestLoading = false
      })
    },
  },
}
</script>
